import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TraceService } from './trace-interceptor.service';

@Injectable({
  providedIn: 'root'
})
export class TrackedMessageService {
  
  constructor(private originalMessageService: MessageService) {}
  
  add(message: any): void {
    const enhancedMessage = { ...message };
    
    if (enhancedMessage.severity === 'error') {
      const traceId = TraceService.getCurrentTraceId();
      
      if (traceId) {
        enhancedMessage.styleClass = 'toast-with-trace';
        
        setTimeout(() => {
          this.addTraceFooterToDOM(traceId);
        }, 150);
        
        TraceService.clearTraceId();
      }
    }
    
    if (!enhancedMessage.life) {
      if (enhancedMessage.severity === 'error' || enhancedMessage.severity === 'warn') {
        enhancedMessage.life = 0;
      } else if (enhancedMessage.severity === 'success') {
        enhancedMessage.life = 5000;
      } else {
        enhancedMessage.life = 0;
      }
    }
    
    this.originalMessageService.add(enhancedMessage);
  }

  private addTraceFooterToDOM(traceId: string): void {
    try {
      const errorToasts = document.querySelectorAll('.p-toast-message-error.toast-with-trace:not(.trace-processed)');
      
      if (errorToasts.length === 0) return;
      
      const latestToast = errorToasts[errorToasts.length - 1] as HTMLElement;
      
      if (latestToast && !latestToast.querySelector('.trace-footer-injected')) {
        latestToast.classList.add('trace-processed');
        
        const footer = document.createElement('div');
        footer.className = 'trace-footer-injected';
        footer.innerHTML = `<span style="opacity: 0.7; margin-right: 6px;">📋</span><span>Trace ID: ${traceId}</span>`;
        
        const messageContent = latestToast.querySelector('.p-toast-message-content') as HTMLElement;
        if (messageContent) {
          messageContent.style.position = 'relative';
          messageContent.appendChild(footer);
        }
      }
    } catch (error) {
    }
  }
  
  addError(summary: string, detail?: string): void {
    this.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: 0
    });
  }
  
  addSuccess(summary: string, detail?: string): void {
    this.add({
      severity: 'success',
      summary: summary,
      detail: detail,
      life: 5000
    });
  }
  
  addInfo(summary: string, detail?: string): void {
    this.add({
      severity: 'info',
      summary: summary,
      detail: detail,
      life: 0
    });
  }
  
  addWarning(summary: string, detail?: string): void {
    this.add({
      severity: 'warn',
      summary: summary,
      detail: detail,
      life: 0
    });
  }
}
